import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { FormHandler, FormComponent as IFormComponent } from '../form-handler';

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {

    constructor(
        private location: Location,
        private formHandler: FormHandler,
        private element: ElementRef
    ) {
        this.isServer = this.formHandler.isServer;
    }

    @Input()
    action: string = null;

    isServer: boolean = false;

    @Input()
    handler: IFormComponent;

    async ngOnInit() {
        if (!this.handler)
            return;

        if (!this.action)
            this.action = this.formHandler.currentPath;

        await this.formHandler.handle(this.handler);

        if (!this.isServer)
            this.populateServerFormData();
    }

    ngAfterViewInit() {
        if (!this.isServer)
            this.focusSelectedElement();
    }

    populateServerFormData() {
        let formData = window['__ssrFormData'];
        if (!formData)
            return;

        let el: Element = this.element.nativeElement;
        let formEl: HTMLFormElement = el.querySelector('form');
        let thisFormData = formData[this.action];
        if (!thisFormData)
            return;

        this.formHandler.applyData(this.handler, thisFormData);
    }

    focusSelectedElement() {
        let formData = window['__ssrFormData'];
        if (!formData)
            return;

        let el: Element = this.element.nativeElement;
        let formEl: HTMLFormElement = el.querySelector('form');

        // Focus...

        if (formData['focused']) {
            let [action, inputName] = formData['focused'];
            if (action == this.action) {
                let input: HTMLInputElement = <any>formEl.querySelector(`[name=${inputName}]`);
                input.focus();
            }
        }
    }

    sendSubmit() {
        if (this.handler)
            this.handler.submit();
    }
}
